var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.$style.img,attrs:{"src":_vm.basePath + 'dropkite-logo-banner.png',"alt":"dropkite.com"}})}
var staticRenderFns = []

export { render, staticRenderFns }